import { OrderPhase, OrderState } from '../../model'

export interface OrderListConfig {
    title: string
    showCreateOrder: boolean
    defaultFilters: {
        phase?: OrderPhase
        state?: OrderState
    }
    showState: boolean
}

export interface OrderListRouteHandle {
    orderList: OrderListConfig
}

export const DEFAULT_ORDER_LIST_CONFIG: OrderListConfig = {
    title: 'Mijn opdrachten',
    showCreateOrder: true,
    defaultFilters: {},
    showState: false
}

export const ARCHIVED_ORDER_LIST_CONFIG: OrderListConfig = {
    title: 'Archief',
    showCreateOrder: false,
    defaultFilters: { phase: OrderPhase.Archived },
    showState: true
}

export const isOrderListRouteHandle = (handle: unknown): handle is OrderListRouteHandle => {
    return typeof handle === 'object' && handle !== null && 'orderList' in handle
}
